// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"96":"b34898a9","149":"81369eca","675":"01d272b4","875":"81369eca"}[chunkId] + ".chunk.css";
};